!function (e, r) {
  for (var n in r) {
    e[n] = r[n];
  }
}(exports, function (e) {
  var r = {};

  function n(t) {
    if (r[t]) return r[t].exports;
    var o = r[t] = {
      i: t,
      l: !1,
      exports: {}
    };
    return e[t].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = r, n.d = function (e, r, t) {
    n.o(e, r) || Object.defineProperty(e, r, {
      enumerable: !0,
      get: t
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, r) {
    if (1 & r && (e = n(e)), 8 & r) return e;
    if (4 & r && "object" == typeof e && e && e.__esModule) return e;
    var t = Object.create(null);
    if (n.r(t), Object.defineProperty(t, "default", {
      enumerable: !0,
      value: e
    }), 2 & r && "string" != typeof e) for (var o in e) {
      n.d(t, o, function (r) {
        return e[r];
      }.bind(null, o));
    }
    return t;
  }, n.n = function (e) {
    var r = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(r, "a", r), r;
  }, n.o = function (e, r) {
    return Object.prototype.hasOwnProperty.call(e, r);
  }, n.p = "", n(n.s = 0);
}([function (e, r, n) {
  "use strict";

  function t(e, r, n) {
    return r in e ? Object.defineProperty(e, r, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = n, e;
  }

  Object.defineProperty(r, "__esModule", {
    value: !0
  });

  var o = function o(e) {
    return e;
  };

  r.createAction = function (e, r, n) {
    var t = "function" == typeof r ? r : r && r.noPayload ? null : o,
        u = function u() {
      var r = (arguments.length <= 0 ? void 0 : arguments[0]) instanceof Error,
          o = {
        type: e
      },
          u = null;
      return null !== t && (u = r ? arguments.length <= 0 ? void 0 : arguments[0] : t.apply(void 0, arguments)), null != u && (o.payload = u), (r || u instanceof Error) && (o.error = !0), "function" == typeof n && (o.meta = n.apply(void 0, arguments)), o;
    };

    return u.toString = function () {
      return e.toString();
    }, u.type = e.toString(), u;
  }, r.action = function (e, r) {
    return {
      type: e,
      payload: r
    };
  }, r.asyncAction = function (e) {
    var r = {
      name: e.baseName,
      start: e.baseName + "_START",
      success: e.baseName + "_SUCCESS",
      error: e.baseName + "_ERROR"
    },
        n = function n(r, _n, t) {
      return function (o) {
        return {
          type: r,
          payload: o,
          request: {
            id: e.baseName,
            isPending: _n,
            error: t ? o : null
          }
        };
      };
    },
        t = {
      start: n(r.start, !0),
      success: n(r.success, !1),
      error: n(r.error, !1, !0)
    },
        o = e.action(t);

    return o.event = r, o;
  }, r.pollingAction = function (e, r) {
    var n = null,
        t = function t() {
      n && clearInterval(n);
    };

    return {
      start: function start(o, u) {
        t(), e(o, u), n = setInterval(function () {
          return e(o, u);
        }, r);
      },
      stop: t
    };
  }, r.parseErrorMiddleware = function (e) {
    return function (e) {
      return function (r) {
        return r.type && r.payload instanceof Error && (r = Object.assign({}, r, {
          payload: r.payload.message
        })), e(r);
      };
    };
  }, r.requests = {
    reducer: function reducer() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          r = arguments[1];
      return r.request ? Object.assign({}, e, t({}, r.request.id, {
        isPending: r.request.isPending,
        error: r.request.error
      })) : e;
    },
    selectIsRequestPending: function selectIsRequestPending(e, r) {
      return !0 === (e.request[r.event.name] || {}).isPending;
    },
    selectRequestError: function selectRequestError(e, r) {
      return (e.request[r.event.name] || {}).error;
    }
  };
}]));